import React, { useRef, useEffect, Suspense } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
// import Login from './pages/login';
import { AuthProvider } from "./redux/action/auth_action";
// import Dashboard from "./pages/Dashboard";
import Loader from "./components/Common/loader";
import AuthLayout from "./components/Layout/AuthLayout";
// import ProtectedRoute from "./components/Common/ProtectedRoute";
import MainLayout from "./components/Layout/MainLayout";
import PanelMaster from "pages/PanelWiseItemMaster";
import FranchiseCopyRate from "pages/FranchiseCopyRates";
import FranchiseInvestigationDetails from "pages/FranchiseInvestigationDetails";
import Receipt from "pages/Estimate/Receipt";
import PatientReceipt from "pages/PatientAppointmentDetail/PatientReceipt";
import TRFWorkSheet from "pages/PatientAppointmentDetail/TRFWorkSheet";
import { useAlert } from "context/alert";
import {
  generateToken,
  messaging,
  onMessageListener,
  requestPermission,
} from "notifications/firebase";
import { onMessage } from "firebase/messaging";
import { useState } from "react";
import ResultEntryPdfHtml from "pages/Report/PatientLabSearchReport/resultEntryHtmlPdf";
import ResultEntryPdf from "./pages/Report/PatientLabSearchReport/resultEntryPdf";
import SampleReportPdf from "./pages/InvestigationManager/SampleReportPdf";
import toast, { Toaster } from "react-hot-toast";
import PanelMasterApproval from "pages/PanelWiseItemMasterApproval";
import PatientDocument from "pages/Report/PatientLabSearchReport/PatientDocument";
import PrintLabel from "components/Common/PrintLabel";
import CommissionReportLedger from "pages/CommissionReportLedger";
import AddObservationValuePage from "pages/Report/PatientLabSearchReport/AddObservationValuePage";
import { AUTH_ERROR_EVENT } from "services/axios";

const Dashboard = React.lazy(() => import("./pages/Dashboard"));
const MarketingPersonDashboard = React.lazy(() =>
  import("./pages/MarketingPersonDashboard")
);
const Login = React.lazy(() => import("./pages/login"));
const Branch = React.lazy(() => import("./pages/Branch"));

const Zone = React.lazy(() => import("./pages/Zone"));
const Area = React.lazy(() => import("./pages/Area"));
const Circular = React.lazy(() => import("./pages/Circular"));
const LabDepartment = React.lazy(() => import("./pages/LabDepartment"));
const CollectionType = React.lazy(() => import("./pages/CollectionType"));
const DepartmentType = React.lazy(() => import("./pages/DepartmentType"));
const FranchiseType = React.lazy(() => import("./pages/FranchiseType"));
const DoctorsDegree = React.lazy(() => import("./pages/DoctorsDegree"));
const DoctorsSepcialization = React.lazy(() =>
  import("./pages/DoctorsSepcialization")
);
const Organism = React.lazy(() => import("./pages/Organism"));
const InvestigationObservation = React.lazy(() =>
  import("./pages/InvestigationObservation")
);
const InvestigationSequence = React.lazy(() =>
  import("./pages/InvestigationSequence")
);
const Franchise = React.lazy(() => import("./pages/Franchise"));
const FranchiseOnboarding = React.lazy(() => import("./pages/FranchiseOnboarding"));
const PendingOnboarding = React.lazy(() => import("./pages/PendingOnboarding"));
const ParentMarginSettlement = React.lazy(() => import("./pages/ParentMarginSettlement"));

const Department = React.lazy(() => import("./pages/Department"));
const Designation = React.lazy(() => import("./pages/Designation"));
const Employee = React.lazy(() => import("./pages/Employee"));
const EmployeeType = React.lazy(() => import("./pages/EmployeeType"));
const EmployeeCategory = React.lazy(() =>
  import("./pages/EmployeeCategoryMaster")
);
const EmployeeLeave = React.lazy(() => import("./pages/EmployeeLeave"));
const EmployeeLeaveLedger = React.lazy(() =>
  import("./pages/EmployeeLeaveLedger")
);
const EmployeeLeaveHistory = React.lazy(() =>
  import("./pages/EmployeeLeaveHistory")
);
const PaymentLedger = React.lazy(() => import("./pages/PaymentLedger"));
const CommissionLedger = React.lazy(() => import("./pages/CommissionLedger"));
const CreditTransfer = React.lazy(() => import("./pages/CreditTransfer"));
const Attendance = React.lazy(() => import("./pages/Attendance"));
const DiscountReasonMaster = React.lazy(() =>
  import("./pages/DiscountReasonMaster")
);

const PaymentMode = React.lazy(() => import("./pages/PaymentMode"));
const Role = React.lazy(() => import("./pages/Roles"));
const Section = React.lazy(() => import("./pages/Sections"));
const Document = React.lazy(() => import("./pages/DocumentMaster"));
const AuditLogs = React.lazy(() => import("./pages/AuditLogs"));
const ShareType = React.lazy(() => import("./pages/ShareType"));
const SampleType = React.lazy(() => import("./pages/SampleType"));
const SampleCollection = React.lazy(() => import("./pages/SampleCollection"));
const SampleRejectionReason = React.lazy(() =>
  import("./pages/SampleRejectionReason")
);
const PaymentType = React.lazy(() => import("./pages/PaymentType"));
const InvestigationTest = React.lazy(() =>
  import("./pages/InvestigationTestMaster")
);
const InvestigationTemplate = React.lazy(() =>
  import("./pages/InvestigationTemplateMaster")
);
const EmpDiscountAllowed = React.lazy(() =>
  import("./pages/EmployeeDiscountAllowed")
);
const InvestigationNabl = React.lazy(() =>
  import("./pages/InvestigationNablMaster")
);
const OutsourceInvestigation = React.lazy(() =>
  import("./pages/OutsourceInvestigationMaster")
);
const OutsourceLab = React.lazy(() => import("./pages/OutsourceLabMaster"));
const Package = React.lazy(() => import("./pages/PackageMaster"));
const TestRate = React.lazy(() => import("./pages/TestRateMaster"));
const PackageInvestigationMaster = React.lazy(() =>
  import("./pages/PackageInvestigationMaster")
);
const InvestigationHelp = React.lazy(() =>
  import("./pages/InvestigationHelpMaster")
);
const Interpretation = React.lazy(() =>
  import("./pages/InvestigationInterpretationMaster")
);
const InvestigationDeliveryDays = React.lazy(() =>
  import("./pages/InvestigationDeliveryDays")
);
const InvestigationComment = React.lazy(() =>
  import("./pages/InvestigationCommentMaster")
);
const InvestigationDetails = React.lazy(() =>
  import("./pages/InvestigationDetailsMaster")
);
const Doctor = React.lazy(() => import("./pages/DoctorMaster"));
const EmployeeFranchiseDetails = React.lazy(() =>
  import("./pages/EmploeeFranchiseDetailsMaster")
);
const Patient = React.lazy(() => import("./pages/PatientMaster"));
const Registration = React.lazy(() => import("./pages/NewRegistration"));
const CampBulkBooking = React.lazy(() => import("./pages/CampBulkBooking"));
const Estimate = React.lazy(() => import("./pages/Estimate"));

const TestRateListExcel = React.lazy(() => import("./pages/TestRateListExcel"));

const FranchiseAdvancePayment = React.lazy(() =>
  import("./pages/FranchiseAdvancePayment")
);

const KycDocument = React.lazy(() => import("./pages/Kyc"));
const MachineData = React.lazy(() => import("./pages/MachineData"));

const InvestigationPackage = React.lazy(() =>
  import("./pages/InvestigationPackage")
);
const PatientAppointmentDetail = React.lazy(() =>
  import("./pages/PatientAppointmentDetail")
);
const PatientLabSearchReport = React.lazy(() =>
  import("./pages/Report/PatientLabSearchReport")
);
const FranchisePatientReport = React.lazy(() =>
  import("./pages/Report/FranchisePatientReport")
);

const RoleWiseRedirectFranchisePatient = React.lazy(() =>
  import("./pages/Report/RoleWiseRedirectFranchisePatient")
);

const PannelWiseBusReport = React.lazy(() =>
  import("./pages/Report/PannelWiseBusReport")
);

const PannelWiseBusReportLims = React.lazy(() =>
  import("./pages/Report/PannelWiseBusReportLims")
);

const PannelWiseBusReportFranchise = React.lazy(() =>
  import("./pages/Report/FranchisePannelWiseBusReport")
);

const PaymentTypeSearchReport = React.lazy(() =>
  import("./pages/Report/PaymentTypeSearchReport")
);

const FranchiseStatisticsReport = React.lazy(() =>
  import("./pages/Report/FranchiseStatisticsReport")
);

const FranchiseStatisticsComparisonReport = React.lazy(() =>
  import("./pages/Report/FranchiseStatisticsComparisonReport")
);

const ZoneStatisticsReport = React.lazy(() =>
  import("./pages/Report/ZoneStatisticsReport")
);

const InvestigationPackageBookingStatistics = React.lazy(() =>
  import("./pages/Report/InvestigationPackageBookingStatistics")
);

const AnalyticsDashboard = React.lazy(() =>
  import("./pages/Report/AnalyticsDashboard")
);

const ApprovedOnboardingReport = React.lazy(() =>
  import("./pages/Report/ApprovedOnboardingReport")
);

const FranchisePaymentReport = React.lazy(() =>
  import("./pages/Report/FranchisePaymentReport")
);

const CommissionReport = React.lazy(() =>
  import("./pages/Report/CommissionReport")
);

const Observation = React.lazy(() => import("./pages/ObservationMaster"));

const InvestigationManager = React.lazy(() =>
  import("./pages/InvestigationManager")
);

const FranchiseFormat = React.lazy(() =>
  import("./components/Common/FranchiseFormat")
);

const NewFranchiseForm = React.lazy(() =>
  import("./components/Common/NewFranchiseForm")
);

// Inventory Routing
const Product = React.lazy(() => import("./pages/Product"));
const Vendor = React.lazy(() => import("./pages/Vendor"));
const TermsCondition = React.lazy(() => import("./pages/TermsCondition"));
const PurchaseOrder = React.lazy(() => import("./pages/PurchaseOrder"));
const ViewPurchaseOrder = React.lazy(() =>
  import("./pages/PurchaseOrder/ViewPurchaseOrder")
);
const StockIn = React.lazy(() => import("./pages/StockIn"));

const Invoice = React.lazy(() => import("./pages/NewRegistration/invoice"));

// const ResultEntryPdf = import("./pages/Report/PatientLabSearchReport/resultEntryPdf")

// const ResultEntryPdf = React.lazy(() =>
//   import("./pages/Report/PatientLabSearchReport/resultEntryPdf")
// );

const ResultEntryHtmlPdf = React.lazy(() =>
  import("./pages/Report/PatientLabSearchReport/resultEntryHtmlPdf")
);

const ResultEntryReactPdf = React.lazy(() =>
  import("./pages/Report/PatientLabSearchReport/resultEntryPdfReact")
);

const ResultEntryPdfDownloadQRCode = React.lazy(() =>
  import("./pages/Report/PatientLabSearchReport/ResultEntryPdfDownloadQRCode")
);

const PaymentSuccess = React.lazy(() =>
  import("./components/Common/Success/PaymentSuccess")
);

const FailurePayment = React.lazy(() =>
  import("./components/Common/Failure/FailurePayment")
);

const AppointmentPayment = React.lazy(() =>
  import("./pages/AppointmentPayment")
);

const OnlinePaymentDetail = React.lazy(() =>
  import("./pages/OnlinePaymentDetails")
);

const MachineMaster = React.lazy(() => import("./pages/MachineMaster"));

const ObservationHostCode = React.lazy(() =>
  import("./pages/ObservationHostCode")
);
const ReportRole = React.lazy(() => import("./pages/ReportRole"));
const AssignRole = React.lazy(() => import("./pages/AssignRole"));
const ReceivedPayment = React.lazy(() => import("./pages/ReceivedPayment"));
const PackageCopyRate = React.lazy(() => import("./pages/PackageCopyRate"));
const Payments = React.lazy(() => import("./pages/Payments"));
const OnlinePaymentsAndReceivePayment = React.lazy(() =>
  import("./pages/OnlinePaymentsAndReceivePayment")
);

const AlertManagement = React.lazy(() => import("./pages/AlertManagement"));
const BarcodeTracking = React.lazy(() => import("./pages/BarcodeTracking"));
const BillResetManagement = React.lazy(() => import("./pages/BillResetManagement"));

const SectionProtectedRoute = ({ sectionId, children }) => {
  const user = useSelector((state) => state.jwtAuthreducer?.user);
  const roles = user?.employee_roles || [];
  const sections = user?.employee_sections || [];
  const isSuperAdmin = roles.some(
    (role) => (role?.role_name || "").trim().toUpperCase() === "SUPER ADMIN"
  );
  const hasSection = sections.some(
    (section) => Number(section?.id) === Number(sectionId)
  );

  return isSuperAdmin || hasSection ? children : <Navigate to="/" replace />;
};

function App() {
  const isMounted = useRef(false);
  const dispatch = useDispatch();
  const login = useSelector((state) => state.jwtAuthreducer);
  const { user } = useSelector((state) => state.jwtAuthreducer);
  const isMarketingPerson = user?.employee_roles?.some(
    (role) => role?.role_name === "Marketing Person"
  );
  const { showAlert } = useAlert();

  useEffect(() => {
    if (isMounted.current) return;
    dispatch(AuthProvider());
    isMounted.current = true;
  }, []);

  // const [notification, setNotification] = useState({ title: "", body: "" });
  // useEffect(() => {
  //   requestPermission();
  //   const unsubscribe = onMessageListener().then((payload) => {
  //     setNotification({
  //       title: payload?.notification?.title,
  //       body: payload?.notification?.body,
  //     });
  //     showAlert(payload.notification.body, "success");
  //   });
  //   return () => {
  //     unsubscribe.catch((err) => console.log("failed: ", err));
  //   };
  // }, []);

  useEffect(() => {
    generateToken();
    onMessageListener();
    onMessage(messaging, (payload) => {
      console.log("payload", payload);

      toast((t) => (
        <div>
          <strong>{payload.notification.title}</strong>
          <p>{payload.notification.body}</p>
        </div>
      ));
    });
  }, []);

  useEffect(() => {
    const handleAuthError = (event) => {
      const message =
        event?.detail?.message ||
        "Your session is invalid. Please log out and log back in.";
      showAlert(message, "warning");
    };

    window.addEventListener(AUTH_ERROR_EVENT, handleAuthError);

    return () => {
      window.removeEventListener(AUTH_ERROR_EVENT, handleAuthError);
    };
  }, [showAlert]);

  // Global error handler for modal focus errors
  useEffect(() => {
    const handleGlobalError = (event) => {
      if (event.error && event.error.message && event.error.message.includes('focus')) {
        console.warn('Modal focus error caught and handled:', event.error.message);
        event.preventDefault();
        return false;
      }
    };

    window.addEventListener('error', handleGlobalError);
    window.addEventListener('unhandledrejection', handleGlobalError);

    return () => {
      window.removeEventListener('error', handleGlobalError);
      window.removeEventListener('unhandledrejection', handleGlobalError);
    };
  }, []);

  if (login.loading) {
    return <Loader />;
  }

  return (
    <div className="App">
      <Toaster position="top-right" />
      <Router>
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/receipt" element={<Receipt />} />
            <Route path="/receipt-patient" element={<PatientReceipt />} />
            <Route path="/receipt-trf-work" element={<TRFWorkSheet />} />
            <Route element={<AuthLayout />}>
              <Route path="/" element={<MainLayout />}>
                <Route
                  index
                  element={
                    isMarketingPerson ? (
                      <MarketingPersonDashboard />
                    ) : (
                      <Dashboard />
                    )
                  }
                />
                <Route path="/branch" element={<Branch />} />

                <Route path="/zone" element={<Zone />} />
                <Route path="/area" element={<Area />} />
                <Route path="/circular" element={<Circular />} />
                <Route path="/collection-type" element={<CollectionType />} />
                <Route path="/lab-department" element={<LabDepartment />} />
                <Route path="/department-type" element={<DepartmentType />} />
                <Route path="/franchise-type" element={<FranchiseType />} />
                <Route
                  path="/discount-reason"
                  element={<DiscountReasonMaster />}
                />
                <Route path="/doctors-degree" element={<DoctorsDegree />} />
                <Route
                  path="/doctors-sepcialization"
                  element={<DoctorsSepcialization />}
                />
                <Route path="/organism" element={<Organism />} />
                <Route
                  path="/investigation-observation"
                  element={<InvestigationObservation />}
                />
                <Route
                  path="/investigation-sequence"
                  element={<InvestigationSequence />}
                />
                <Route path="/franchise" element={<Franchise />} />
                <Route path="/franchise-onboarding" element={<FranchiseOnboarding />} />
                <Route path="/pending-onboarding" element={<PendingOnboarding />} />
                <Route path="/parent-margin-settlement" element={<ParentMarginSettlement />} />

                <Route path="/department" element={<Department />} />
                <Route path="/designation" element={<Designation />} />
                <Route path="/employee" element={<Employee />} />
                <Route path="/employeeType" element={<EmployeeType />} />
                <Route
                  path="/employeeCategory"
                  element={<EmployeeCategory />}
                />
                <Route path="/employeeLeave" element={<EmployeeLeave />} />
                <Route
                  path="/leaveLedgerSummary"
                  element={<EmployeeLeaveLedger />}
                />
                <Route
                  path="/leaveHistory"
                  element={<EmployeeLeaveHistory />}
                />
                <Route path="/attendance-report" element={<Attendance />} />
                <Route path="/paymentMode" element={<PaymentMode />} />
                <Route path="/payment-ledger" element={<PaymentLedger />} />
                <Route
                  path="/commission-ledger"
                  element={<CommissionLedger />}
                />
                <Route path="/credit-transfer" element={<CreditTransfer />} />
                <Route path="/roles" element={<Role />} />
                <Route path="/sections" element={<Section />} />
                <Route path="/document" element={<Document />} />
                <Route path="/audit-logs" element={<AuditLogs />} />
                <Route path="/shareType" element={<ShareType />} />
                <Route path="/sampleType" element={<SampleType />} />
                <Route
                  path="/sampleRejectionReason"
                  element={<SampleRejectionReason />}
                />
                <Route path="/payment-type" element={<PaymentType />} />
                <Route
                  path="/investigation-test"
                  element={<InvestigationTest />}
                />
                <Route
                  path="/investigation-manager"
                  element={<InvestigationManager />}
                />
                <Route
                  path="/sample-collection"
                  element={<SampleCollection />}
                />

                <Route
                  path="/investigation-template"
                  element={<InvestigationTemplate />}
                />
                <Route
                  path="/emp-discount-allowed"
                  element={<EmpDiscountAllowed />}
                />
                <Route
                  path="/investigation-nabl"
                  element={<InvestigationNabl />}
                />
                <Route
                  path="/outsource-investigation"
                  element={<OutsourceInvestigation />}
                />
                <Route path="/outsource-lab" element={<OutsourceLab />} />
                <Route path="/package" element={<Package />} />
                <Route path="/test-rate" element={<TestRate />} />
                <Route path="/panel-master" element={<PanelMaster />} />
                <Route
                  path="/franchise-copy-rates"
                  element={<FranchiseCopyRate />}
                />
                <Route
                  path="/franchise-investigation-details"
                  element={<FranchiseInvestigationDetails />}
                />
                <Route
                  path="/panel-master-approval"
                  element={<PanelMasterApproval />}
                />
                <Route
                  path="/package-investigation"
                  element={<PackageInvestigationMaster />}
                />
                <Route
                  path="/investigation-help"
                  element={<InvestigationHelp />}
                />
                <Route
                  path="/investigation-interpretation"
                  element={<Interpretation />}
                />
                <Route
                  path="/investigation-deliveryDays"
                  element={<InvestigationDeliveryDays />}
                />
                <Route
                  path="/investigation-comment"
                  element={<InvestigationComment />}
                />
                <Route
                  path="/investigation-details"
                  element={<InvestigationDetails />}
                />
                <Route path="/doctors" element={<Doctor />} />
                <Route
                  path="/employee-franchise-details"
                  element={<EmployeeFranchiseDetails />}
                />
                <Route path="/patient" element={<Patient />} />
                <Route path="/registration" element={<Registration />} />
                <Route path="/camp-bulk-booking" element={<CampBulkBooking />} />
                <Route
                  path="/investigationpackage"
                  element={<InvestigationPackage />}
                />
                <Route
                  path="/patient-appointment-details"
                  element={<PatientAppointmentDetail />}
                />
                <Route
                  path="/panne-wise-bus-report"
                  element={<PannelWiseBusReport />}
                />
                <Route
                  path="/lims-panel-wise-bus-report"
                  element={<PannelWiseBusReportLims />}
                />
                <Route
                  path="/franchise-panel-wise-bus-report"
                  element={<PannelWiseBusReportFranchise />}
                />
                <Route
                  path="/patient-wise-search-report"
                  element={<PatientLabSearchReport />}
                />
                <Route
                  path="/patient-report"
                  element={<FranchisePatientReport />}
                />
                <Route
                  path="/observation-entry"
                  element={<AddObservationValuePage />}
                />
                <Route
                  path="/role-wise-patient-report"
                  element={<RoleWiseRedirectFranchisePatient />}
                />
                <Route
                  path="/payment-type-search-report"
                  element={<PaymentTypeSearchReport />}
                />
                <Route
                  path="/franchise-statistics-report"
                  element={<FranchiseStatisticsReport />}
                />
                <Route
                  path="/franchise-statistics-comparison-report"
                  element={<FranchiseStatisticsComparisonReport />}
                />
                <Route
                  path="/zone-statistics-report"
                  element={<ZoneStatisticsReport />}
                />
                <Route
                  path="/investigation-package-booking-statistics"
                  element={<InvestigationPackageBookingStatistics />}
                />
                <Route
                  path="/analytics-dashboard"
                  element={<AnalyticsDashboard />}
                />
                <Route
                  path="/franchise-payment-ledger"
                  element={<FranchisePaymentReport />}
                />
                <Route
                  path="/total-onboarding-data-report"
                  element={<ApprovedOnboardingReport />}
                />
                <Route
                  path="/commission-report"
                  element={<CommissionReport />}
                />

                <Route path="/observation" element={<Observation />} />

                <Route path="/estimate" element={<Estimate />} />

                <Route
                  path="/franchise-advance-payment-list"
                  element={<FranchiseAdvancePayment />}
                />

                <Route path="/kyc-documents" element={<KycDocument />} />
                <Route path="/machine-data" element={<MachineData />} />

                <Route
                  path="/test-rate-list-excel"
                  element={<TestRateListExcel />}
                />

                <Route
                  path="/appointment-payment"
                  element={<AppointmentPayment />}
                />

                <Route
                  path="/online-payment-details"
                  element={<OnlinePaymentDetail />}
                />

                <Route
                  path="/appointment-payment/advancepayment-success"
                  element={<PaymentSuccess />}
                />

                <Route
                  path="/appointment-payment/advancepayment-failure"
                  element={<FailurePayment />}
                />

                <Route path="/machine-master" element={<MachineMaster />} />

                <Route
                  path="/observation-host-code"
                  element={<ObservationHostCode />}
                />

                <Route path="/report-role" element={<ReportRole />} />
                <Route
                  path="/commission-report-ledger"
                  element={<CommissionReportLedger />}
                />

                <Route path="/assign-role" element={<AssignRole />} />

                <Route path="/received-payment" element={<ReceivedPayment />} />
                <Route
                  path="/package-copy-rate"
                  element={<PackageCopyRate />}
                />
                <Route path="/payments" element={<Payments />} />
                <Route
                  path="/online-payments-and-receive-payment"
                  element={<OnlinePaymentsAndReceivePayment />}
                />

                <Route path="/print-label-exe" element={<PrintLabel />} />

                {/* <Route path="/*" element={<Navigate to="/" />} /> */}

                <Route path="/franchiseFormat" element={<FranchiseFormat />} />
                <Route path="/new-franchise" element={<NewFranchiseForm />} />

                {/* Inventory Routing */}
                <Route path="/product" element={<Product />} />
                <Route path="/vendor" element={<Vendor />} />
                <Route path="/terms-condition" element={<TermsCondition />} />
                <Route path="/purchase-order" element={<PurchaseOrder />} />
                <Route
                  path="/view-purchase-order"
                  element={<ViewPurchaseOrder />}
                />
                <Route path="/stock-in" element={<StockIn />} />
                {/* Alerts */}
                 <Route path="/alert-management" element={<AlertManagement />} />
                 <Route
                   path="/barcode-tracking"
                   element={
                     <SectionProtectedRoute sectionId={97}>
                       <BarcodeTracking />
                     </SectionProtectedRoute>
                   }
                 />
                 <Route path="/bill-reset" element={<BillResetManagement />} />
              </Route>
            </Route>
            <Route path="/invoice" element={<Invoice />} />
            <Route path="/ResultEntryPdf" element={<ResultEntryPdf />} />
            <Route path="/SampleReportPdf" element={<SampleReportPdf />} />
            <Route path="/patient-document" element={<PatientDocument />} />
            <Route
              path="/ResultEntryHtmlPdf"
              element={<ResultEntryHtmlPdf />}
            />
            <Route
              path="/ResultEntryReactPdf"
              element={<ResultEntryReactPdf />}
            />
            <Route
              path="/lims/reports/:token"
              element={<ResultEntryPdfDownloadQRCode />}
            />

           

            {/* <Route exact path="/" element={<Login />} />
            <Route path="/dashboard" element={<ProtectedRoute element={<Dashboard />} />} />
            <Route path="/create/department" element={<ProtectedRoute element={<AddDepartment />} />} />
            <Route path="/create/branch" element={<ProtectedRoute element={<BranchManager />} />} />
            <Route path="/create/role" element={<ProtectedRoute element={<AddRoles />} />} />
            <Route path="/create/designation" element={<ProtectedRoute element={<AddDesignation />} />} />
            <Route path="/create/paneltype" element={<ProtectedRoute element={<AddPanelType />} />} />
            <Route path="/create/zone" element={<ProtectedRoute element={<AddZoneMaster />} />} />
            <Route path="/create/circularmaster" element={<ProtectedRoute element={<AddCircularMaster />} />} />
            <Route path="/branch/listing" element={<ProtectedRoute element={<BranchListing />} />} /> */}
          </Routes>
        </Suspense>
      </Router>
    </div>
  );
}

export default App;
